import React from 'react';
import ReactDOM from 'react-dom';
import Admin from './components/Admin';
import './css/index.css';

ReactDOM.render(
    <Admin />,
    document.getElementById('root')
);
